module.exports = __webpack_public_path__ + "static/20automotive-562a4f2079767ba9ffd1f18f73bbd9de.png";